export { default as useUniversalFilterOperationType } from './useUniversalFilterOperationType';
